import { render, staticRenderFns } from "./ClientFilter.vue?vue&type=template&id=1875ef8c&scoped=true"
import script from "./ClientFilter.vue?vue&type=script&lang=js"
export * from "./ClientFilter.vue?vue&type=script&lang=js"
import style0 from "./ClientFilter.vue?vue&type=style&index=0&id=1875ef8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875ef8c",
  null
  
)

export default component.exports